var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('router-view'),_c('notifications',{attrs:{"classes":"main-notification","position":"bottom right","group":"main"}}),_c('notifications',{attrs:{"classes":"main-notification","position":"bottom center","group":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }